module.exports = __webpack_public_path__ + "img/journal_has_note.ad05ad1f.svg";